/**
 * Hlavička – mobilní menu.
 *
 *  - hamburger: aria-expanded, zavření Escapem, klikem na položku i mimo menu
 */
function initMenu() {
    const btn = document.querySelector('.header-hmb-btn');
    const nav = document.getElementById('header-nav');
    if (!btn || !nav) return;

    const setOpen = (open) => {
        btn.setAttribute('aria-expanded', String(open));
        btn.setAttribute('aria-label', open ? 'Zavřít menu' : 'Otevřít menu');
        nav.classList.toggle('is-open', open);
        document.documentElement.style.overflow = open ? 'hidden' : '';
    };

    btn.addEventListener('click', () => setOpen(btn.getAttribute('aria-expanded') !== 'true'));
    nav.addEventListener('click', (e) => { if (e.target.closest('a')) setOpen(false); });
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') {
            setOpen(false);
            btn.focus();
        }
    });
}

/**
 * Zajížděcí hlavička: při rolování dolů zajede nahoru (víc místa pro obsah),
 * jakmile návštěvník rolne kousek nahoru, zase vyjede. Nahoře stránky,
 * s otevřeným menu nebo s fokusem v hlavičce zůstává vždy vidět
 * (klávesnice nesmí ztratit fokus pod schovanou hlavičkou – WCAG 2.4.7).
 */
function initAutoHide() {
    const header = document.getElementById('header');
    if (!header) return;

    const TOLERANCE = 8;   // drobné cuknutí kolečkem/prstem hlavičku nepřepne
    let lastY = window.scrollY;
    let ticking = false;

    const update = () => {
        ticking = false;
        const y = window.scrollY;
        const delta = y - lastY;
        if (Math.abs(delta) < TOLERANCE) return;

        const keepVisible = y < header.offsetHeight * 2
            || header.querySelector('[aria-expanded="true"]')
            || header.contains(document.activeElement);

        header.classList.toggle('is-hidden', !keepVisible && delta > 0);
        lastY = y;
    };

    window.addEventListener('scroll', () => {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });

    header.addEventListener('focusin', () => header.classList.remove('is-hidden'));
}

initMenu();
initAutoHide();
